<template>
    <div class="soft__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="title animate__animated animate__fadeIn"><span>战略合作品牌</span></div>
        <div class="wrapper__w">
            <div class="cate__ul">
<!--                <div class="active">软装</div>-->
                <router-link v-for="(item, index) in cateList" :key="index" tag="div" active-class="active" :to="item.path" >{{item.name}}</router-link>
            </div>
            <!--软装-->
            <div class="cate__imgs animate__animated animate__fadeIn" v-if="indexShow == 0">
                <img :src="icon_demo1">
            </div>
            <!--基材1-->
            <div class="base__material" v-if="indexShow == 1">
                <!--01-->
                <div>
                    <el-row :gutter="30" class="animate__animated animate__fadeIn">
                        <el-col :span="12">
                            <div class="base__material--imgbg">
                                <img :src="icon_ba01">
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div style="width: 90%" >
                                <div class="">
                                    <div class="base__material--tit">不锈钢钢管</div>
                                    <div class="base__material--des">316L不锈钢医用级标准，SUS304不锈钢食品级标准，不锈钢钢管使用寿命与建筑一致，使用寿命为70年。</div>
                                </div>
                                <div class="base__material--img abs">
                                    <img :src="icon_ba02">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!--02-->
                <div style="margin-top: 40px">
                    <el-row :gutter="30"  class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <el-col :span="11">
                            <div class="relative"  style="padding: 0 10%">
                                <div class="base__material__down">
                                    <img :src="icon_down">
                                </div>
                                <div class="base__material--tit">高耐板</div>
                                <div class="base__material--des">高耐板是专门为人流密度较大的场合而开发生产的具有高抗冲击性能的轻质板材。其石膏芯体比普通纸面石膏板的芯体含有更多的纤维，同时控制了发泡剂的掺入量，并且加入特殊添加剂，这使得它比普通纸面石膏板具有更高的密度，其护面纸也采用了经过增厚处理的高密度进口纸张，不论从芯体还是护面纸都从根本上满足了石膏板的抗冲击性要求。</div>
                            </div>
                        </el-col>
                        <el-col :span="13">
                            <div class="relative">
                                <div class="base__material--imgbg">
                                    <img :src="icon_ba04" style="margin-left: 30px">
                                </div>
                                <div class="gray__bg"></div>
                                <div class="base__material--img base__material--imgleft">
                                    <img :src="icon_ba03">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!--03-->
                <div style="margin-top: 140px">
                    <el-row :gutter="30" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <el-col :span="12">
                            <div class="base__material--imgbg">
                                <img :src="icon_ba06">
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div style="width: 90%">
                                <div>
                                    <div class="base__material--tit">蜂窝板</div>
                                    <div class="base__material--des">蜂窝材料是一种复合材料，在航空航天领域通常称其为蜂窝结构。蜂窝结构是一种夹层结构，其夹芯层由一系列六边形、四边形或其他形状的形似蜂窝的孔格组成，并在夹芯层的上下两面胶接（或钎焊）上较薄的面板/蒙皮。蜂窝结构比其他形式的夹层结构具有更高的强度和刚度。具有稳定、环保的特点。</div>
                                </div>
                                <div class="base__material--img abs">
                                    <img :src="icon_ba05">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!--04-->
                <div style="margin-top: 50px">
                    <el-row :gutter="30" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <el-col :span="11">
                            <div class="relative" style="padding: 0 10%">
                                <div class="base__material__down" style="bottom: -300px;">
                                    <img :src="icon_down">
                                </div>
                                <div class="base__material--tit">黄麻板</div>
                                <div class="base__material--des">
                                    麻板本身没有任何的污染，纯天然植物提取而成，而且有多种功能，是乳胶漆和壁纸等传统材料无法比拟的。
                                    净化除味麻纤维具备独特的“分子筛”结构，具有极强的物理吸附性和离子交换功能，可以有效去除空气中的游离甲醛、苯、氨等有害物质及因宠物、吸烟、垃圾所产生的气味，净化室内空气。麻板具有耐摩擦、耐高温、散热快、不易撕裂、不易燃烧，无静电、耐酸碱高等独特的优点。很好的诠释了麻板的防火阻燃、防水调湿、防霉等特性。
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="13">
                            <div class="relative">
                                <div class="base__material--imgbg">
                                    <img :src="icon_ba08" style="margin-left: 30px">
                                </div>
                                <div class="gray__bg"></div>
                                <div class="base__material--img base__material--imgleft">
                                    <img :src="icon_ba07">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!--基材2-->
        <div v-if="indexShow == 1">
            <!--05-->
            <div class="relative wrapper__wpd base__material" style="margin-top: 140px">
                <el-row :gutter="30" class="relative wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" style="z-index: 22;">
                    <el-col :span="12">
                        <div class="base__material--imgbg">
                            <img :src="icon_ba09">
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="width: 90%">
                            <div>
                                <div class="base__material--tit">喷绘石膏</div>
                                <div class="base__material--des">
                                    粉刷石膏是一种新型多功能建筑内墙及顶板表面的抹面材料，具备以下优点</br>
                                    （1）粘结力强，不空鼓，不开裂，施工质量好 </br> 
                                    （2）装饰性强，墙面洁白，致密，光滑，不起灰，无气味，无裂缝  </br>
                                    （3）保温，隔热，节能 </br>
                                    （4）具有呼吸功能，自动调节室内温度，创造良好生活环境</br>
                                </div>
                            </div>
                            <div class="base__material--img abs">
                                <img :src="icon_ba10">
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="gray__bg" style="height: 262px;top: 37%;width: 30%;left: 0"></div>
            </div>
            <!--06-->
            <div class="relative wrapper__wpd" style="margin-top: 120px">
                <el-row :gutter="0" class="relative wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" style="z-index: 22;">
                    <el-col :span="12">
                        <div class="base__material--footerleft" :style="{background: 'url('+icon_ba11+')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
                            <div class="tit">大师漆</div>
                            <div class="des">PPG大师漆是PPG在华建筑涂料的主要品牌之一，在业界一直保持技术高端地位。融合了PPG在汽车，航空及工业涂料等领域的先进科技和创新，PPG大师漆致力于研发超低VOC和VOCFree的环保涂料。</div>
                        </div>
                    </el-col>
                    <el-col :span="12" style="padding-right: 0">
                        <div class="base__material--footerright"><img :src="icon_ba13"></div>
                    </el-col>
                    <el-col :span="12" style="padding-right: 0">
                        <div class="base__material--footerright"><img :src="icon_ba14"></div>
                    </el-col>
                    <el-col :span="12">
                        <div class="base__material--footerleft" :style="{background: 'url('+icon_ba12+')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
                            <div class="tit">美国本杰明摩尔</div>
                            <div class="des">
                                2000s–Eco Spec®通过绿色卫士Greenguard室内空气质量标准，得到绿色卫士环境研究所认证；同时得到了绿印Green Seal®认证。
                                2008–美国本杰明涂料“最环保涂料”Natura®推出。基于Gennex®水性色浆系统，是当时北美唯一的在任何光泽度下，调色后VOC仍为零的涂料。
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="base__material--footercenter"><img :src="icon_ba15"></div>
            </div>
        </div>
        <!--主材-->
        <div class="relative" v-if="indexShow == 2">
            <div class="gray__bg" style="height: 522px;top: 280px;left: 0;z-index: 1"></div>
            <div class="wrapper__w barnd__banner relative" :style="{background: 'url('+icon_br01+')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
                <div class="relative animate__animated  animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                    <div class="tit">全屋系统介绍</div>
                    <div class="des">
                        从安全、健康、舒适、乐享、智能 五大<br>
                        维度打造高端智慧生活
                    </div>
                </div>
            </div>
            <div class="wrapper__w relative" style="z-index: 2">
                <div class="barnd__type--cate wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                    <div class="tit">业内领先材料配套体系 甄选家居尖货</div>
                    <div class="des">国内外一线大牌战略合作，材料整合能力领先全行业， 敢于保质保价，保100%放心</div>
                </div>
                <div class="over barnd__type--logo" >
                    <div class="fl wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" v-for="(item,index) in logoArr" :key="index" ><img :src="item"></div>
                </div>
                <div >
                    <div  v-for="(item, index) in brandListTable" :key="index" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <div class="table__type">{{item.name}}</div>
                        <div>
                            <el-table
                                    :span-method="objectSpanMethod"
                                    :data="item.tableData"
                                    border
                                    style="width: 100%">
                                <el-table-column
                                        align="center"
                                        class="text__center"
                                        prop="category"
                                        label="品类"
                                        width="180">
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        width="250"
                                        class="text__center"
                                        prop="category_sub"
                                        label="子品类">
                                </el-table-column>
                                <el-table-column
                                        class="text__center"
                                        prop="brand_logo"
                                        width="210"
                                        label="品牌">
                                        <template slot-scope="scope">
                                            <img :src="its" v-for="(its, inde) in scope.row.brand_logo" :key="inde" style="width: 100%;object-fit: contain;background: #fff">
                                        </template>
                                </el-table-column>
                                <el-table-column
                                        prop="des"
                                        label="系统特点介绍">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 150px">
            <Footer></Footer>
        </div>

    </div>
</template>

<script>
    import icon_stra from '@/assets/img/strabanner.png'
    import icon_demo1 from '@/assets/img/demo1.png'
    import icon_ba01 from '@/assets/img/ba01.png'
    import icon_ba02 from '@/assets/img/ba02.png'
    import icon_ba03 from '@/assets/img/ba03.png'
    import icon_ba04 from '@/assets/img/ba04.png'
    import icon_ba05 from '@/assets/img/ba05.png'
    import icon_ba06 from '@/assets/img/ba06.png'
    import icon_ba07 from '@/assets/img/ba07.png'
    import icon_ba08 from '@/assets/img/ba08.png'
    import icon_ba09 from '@/assets/img/ba09.png'
    import icon_ba10 from '@/assets/img/ba10.png'
    import icon_ba11 from '@/assets/img/ba11.png'
    import icon_ba12 from '@/assets/img/ba12.png'
    import icon_ba13 from '@/assets/img/ba13.jpg'
    import icon_ba14 from '@/assets/img/ba14.jpg'
    import icon_ba15 from '@/assets/img/ba15.png'

    import icon_br01 from '@/assets/img/br01.png'
    import balogo1 from '@/assets/img/balogo/1.png'
    import balogo2 from '@/assets/img/balogo/2.png'
    import balogo3 from '@/assets/img/balogo/3.png'
    import balogo4 from '@/assets/img/balogo/4.png'
    import balogo5 from '@/assets/img/balogo/5.png'
    import balogo6 from '@/assets/img/balogo/6.png'
    import balogo7 from '@/assets/img/balogo/7.png'
    import balogo8 from '@/assets/img/balogo/8.png'
    import balogo9 from '@/assets/img/balogo/9.png'
    import balogo10 from '@/assets/img/balogo/10.png'


    import int1 from '@/assets/img/int/1.jpg'
    import int2 from '@/assets/img/int/2.jpg'
    import int3 from '@/assets/img/int/3.jpg'
    import int4 from '@/assets/img/int/4.jpg'
    import int5 from '@/assets/img/int/5.jpg'
    import int6 from '@/assets/img/int/6.jpg'
    import int7 from '@/assets/img/int/7.png'
    import int8 from '@/assets/img/int/8.png'
    import int9 from '@/assets/img/int/9.jpg'
    import int10 from '@/assets/img/int/10.jpg'
    import int11 from '@/assets/img/int/11.jpg'
    import int12 from '@/assets/img/int/12.png'
    import int13 from '@/assets/img/int/13.png'
    import int14 from '@/assets/img/int/14.jpg'
    import int15 from '@/assets/img/int/15.jpg'
    import int16 from '@/assets/img/int/16.png'
    import int17 from '@/assets/img/int/17.png'
    import int18 from '@/assets/img/int/18.png'

    import int19 from '@/assets/img/int/19.png'
    import int20 from '@/assets/img/int/20.png'
    import int22 from '@/assets/img/int/22.png'
    import int23 from '@/assets/img/int/23.png'
    import int24 from '@/assets/img/int/24.png'
    import int25 from '@/assets/img/int/25.png'
    import int26 from '@/assets/img/int/26.jpg'
    import int21 from '@/assets/img/int/21.jpg'

    import int27 from '@/assets/img/int/27.png'
    import int28 from '@/assets/img/int/28.jpg'
    import int29 from '@/assets/img/int/29.png'
    import int30 from '@/assets/img/int/30.jpeg'
    import int31 from '@/assets/img/int/31.jpg'
    import int32 from '@/assets/img/int/32.png'
    import int33 from '@/assets/img/int/33.png'
    import int34 from '@/assets/img/int/34.png'





    import NavSecond from '@/components/NavSecond'
    import icon_down from '@/assets/img/down.png'
    import Footer from '@/layouts/Footer'

    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                icon_demo1, icon_ba01, icon_ba02, icon_ba03, icon_ba04, icon_down, icon_ba05, icon_ba06, icon_ba07, icon_ba08, icon_ba09, icon_ba10,icon_ba11, icon_ba12, icon_ba13, icon_ba14, icon_ba15,
                icon_br01,
                indexShow: 0,
                cateList: [
                    {
                        name: '软装',
                        path: '/strategic/soft/0'
                    },
                    {
                        name: '基材',
                        path: '/strategic/soft/1'
                    },
                    {
                        name: '主材',
                        path: '/strategic/soft/2'
                    }
                ],
                activeName: '0',
                logoArr: [balogo1,balogo2,balogo3,balogo4,balogo5,balogo6,balogo7,balogo8,balogo9,balogo10],
                brandListTable: [
                    {
                        name: '空调系统',
                        tableData: [{
                            id:1,
                            category: '氟系统空调',
                            category_sub: '',
                            brand_logo: [int1,int2,int3],
                            des: '通过外机压缩机和内机蒸发器改变传输介质（氟利昂）的物理形态，来达成搬运冷/热量，达成制冷/制热的效果。有以下优点:\n' +
                                '1、快速制冷制热\n' +
                                '2、节能省电  \n' +
                                '3、噪音低，无漏水隐患\n' +
                                '4、清洗简单，使用寿命长'
                        },{
                            id:2,
                            category: '水系统空调',
                            category_sub: '地源热泵系统',
                            brand_logo: [int4,int5,int6],
                            des: '在自然界中，水总是由高处流向低处，热量也总是从高温传向低温。人们可以用水泵把水从低处抽到高处，实现水由低处向高处流动，热泵同样可以把热量从低温传递到高温。\n' +
                                ' 所以热泵实质上是一种热量提升装置，工作时它本身消耗很少一部分电能，却能从环境介质（水、空气、土壤等）中提取4-7倍于电能的装置，提升温度进行利用，这也是热泵节能的原因。\n' +
                                '地源热泵是热泵的一种，是以大地或水为冷热源对建筑物进行冬暖夏凉的空调技术，地源热泵只是在大地和室内之间“转移”能量。利用极小的电力来维持室内所需要的温度。\n'
                        },{
                            id:3,
                            category: '水系统空调',
                            category_sub: '风冷热泵系统',
                            brand_logo: [int4,int5,int6],
                            des: '风冷热泵型空调机组管路内的水经空调主机内部处理成冷冻水或热水，由水泵的动力作用经管道输送到各个房间的风机盘管内，通过风机盘管的风机运转送风，使室内空气温度降低或升高，健康环保送风均匀。\n' +
                                '根据室内房间的不同需要采用顶送顶回或侧出顶回，室外主机采用风冷热泵型空调机组来制冷、制热。根据别墅空调的使用特点，可配套选择采用局部空调新风系统设计方案，另外采用锅炉或者地暖补充采暖。'
                        },{
                            id:4,
                            category: '全空气系统空调',
                            category_sub: '',
                            brand_logo: [int7],
                            des: '全屋生态环境系统，也称全效生态空气调节系统。其对居室内的空气调节不局限于温度，而是对体感温度、空气相对湿度、新鲜度、气流组织度、洁净度，进行全方位的调节，使得室内空气达到恒温、恒湿、恒氧，微气流、低噪音，去除pm0.3、滤尘、灭菌、分解甲醛和异味的全效健康效果。'
                        },{
                            id:5,
                            category: '辐射冷暖系统空调',
                            category_sub: '毛细管辐射系统',
                            brand_logo: [int8],
                            des: '毛细管辐射空调系统是一种可代替常规中央空调的新型节能舒适空调。系统以水作为冷媒载体，通过均匀紧密的毛细管席（一般管体4.3mm*0.8mm，间距10mm20mm40mm）辐射传热。由于该系统所需的夏季冷冻源供水温度只需17-19度供回水温度，冬季只需32-30度供回水温度，大大低于常规水空调夏季7-12度和冬季45-40度供回水所需的能耗，因而系统更节能。'
                        },{
                            id:6,
                            category: '辐射板空调系统',
                            category_sub: '辐射板空调系统',
                            brand_logo: [int9, int10],
                            des: '以全年为整体，全面解决人们对居住环境的温度、湿度、空气品质、洁净度和生活冷热水等方面的需求，为中国的尊贵业主精心打造的一套高效节能、高舒适度、高性能且适应中国气候条件的全新高科技室内环境系统！'
                        }]
                    },
                    {
                        name: '采暖系统',
                        tableData: [{
                            category: '暖气片',
                            category_sub: '',
                            brand_logo: [int12],
                            des: '1、传播速度快；\n' +
                                '2、热效率高：普通水暧的热效率一般是40-60%,超导暖气片的热效革可达95%以上；\n' +
                                '3、节省能源；\n' +
                                '4、外形美观.易清洗；\n' +
                                '5、可以作为装饰品。'
                        },{
                            category: '水地暖',
                            category_sub: '',
                            brand_logo: [int11],
                            des: '散热均匀，人体先从脚感知温度，在室内采用地暖相对于墙暖更加的舒适。不会占用室内的空间；不仅可以制热，而且还可以提供生活热水使用，并且地暖使用期限可长达50年之上。 '
                        },{
                            category: '电地暖',
                            category_sub: '',
                            brand_logo: [int11],
                            des: '铺设成本基本只与面积相关，小面积    铺设更方便，便于装修和摆放家具\n' +
                                '占用层高较水暖少；\n' +
                                '传热速度快；\n' +
                                '使用寿命长，免维护，不需清洗；\n'
                        }]
                    },
                    {
                        name: '新风除湿系统',
                        tableData: [{
                            category: '新风',
                            category_sub: '',
                            brand_logo: [int12,int13],
                            des: '中央新风系统可以提供人体健康所需的新鲜空气。送入室内的新鲜空气由于氧气渗透压不同，会逐步由新风送风口扩散到室内各个角落。全部送风均来自室外的新鲜空气，室内的污浊空气则由统一的排风管集中排放到室外。中央新风系统能够进行室内空气置换、净化、流动，在排出室内污染空气的同时，输入100%自然新鲜空气，并经过有效过滤、预热等多项预处理后再送入室内。目前有多送多回，多送点回，下送（墙送）顶回等换气方式。'
                        },{
                            category: '新风除湿',
                            category_sub: '',
                            brand_logo: [int14],
                            des: '新风除湿系统可以达到中央除湿、通风，并且根据客户设定的湿度值自动除湿，无需人工值守。同时在循环以及除湿的时候具有净化空气的功能，让生活空间的空气新鲜的同时达到合适的湿度。'
                        },{
                            category: '机械式通风系统',
                            category_sub: '',
                            brand_logo: [int15, int13, int12],
                            des: '一个健康、舒适、可控制的通风系统。它将室内的污浊空气经热回收后排向室外，同时，室外的新鲜空气经过滤网处理后再进入高效热回收器，然后连续地均匀地送入室内，给您创造了一个隔音、无尘、舒适的健康居住空间。    '
                        }]
                    },
                    {
                        name: '中央除尘系统',
                        tableData: [{
                            category: '中央吸尘系统',
                            category_sub: '',
                            brand_logo: [int16,int17],
                            des: '在进行清洁的时候只需要把吸尘软管的接头插入墙面阀门吸口然后再打开手柄上的控制开关，吸尘系统就可以正常的工作了，因此使用这种清洁系统特别的方便，也省去了人工操作的麻烦。因为它的吸力是普通的吸尘器的5倍，所以它可以有效的吸除室内的灰尘以及一些不清洁的空气，然后再通过吸尘系统的真空吸尘管道把灰尘和空气吸入到中央吸尘主机里面进行气尘分离，而如果微尘的体积大于零点三微米的话，就会直接的阻截在集尘桶的外部，然后再通过主机消音器装置把尾气全部都排出到室外。这样就可以有效的保证清洁的效果，同时又可以有效的延长吸尘系统的使用寿命。'
                        },{
                            category: '吸尘清洗系统',
                            category_sub: '',
                            brand_logo: [int16,int17,int18],
                            des: '直接将垃圾废水排入下水道中，这样能杜绝二次染污呢，将深藏在地毯、木地板、瓷砖、家具、楼梯、汽车内部等室内设施中的微小灰尘、细菌、螨虫、花粉等对人体有害的易挥发的气体颗粒彻底清除，使您的呼吸系统免受过敏和疾病的侵害，从而有效防止室内空气中灰尘细菌的再循环。'
                        }]
                    },
                    {
                        name: '水系统',
                        tableData: [{
                            category: '生活热水系统',
                            category_sub: '',
                            brand_logo: [int19,int20],
                            des: '提供生活热水保障。高效，节能，恒温;中央热水系统，集舒适、安全方便、及时于一体。简单的说就是指热水集中在一个地方产生，大容量的热水可以同时、多头通过保温管道供给从浴室到厨房的所有家庭生活用热水点。 \n' +
                                '中央热水系统特别适用于有两个或多个卫生间的大房型、复式房屋或公寓、别墅等。配备了中央热水系统，家就像宾馆，24小时热水，想洗就洗，想用就用\n' +
                                '                            '
                        },{
                            category: '全屋净水系统',
                            category_sub: '',
                            brand_logo: [int21],
                            des:'系统有效的保障业主用水品质，洗澡更柔顺。\n' +
                                '中央水处理系统包括前置过滤、净水、软水、纯水、末端直饮水机等设备。前置过滤设备安装与入户总管道口，可过滤供水管网中产生的沉淀杂质，对水管和安装在水管上的积水设备起到预保护作用。 \n' +
                                '中央水处理系统可以去除水里杂质、杀菌，降低水的硬度，实现家庭用水的各种需求，保护自己和家人的健康。 \n' +
                                '                            '
                        },{
                            category: '活水系统',
                            category_sub: '',
                            brand_logo: [int22,int23],
                            des: '系统做到新鲜活水，恒温恒压，即开即热，且达到60%的同开率，有效提高业主的生活用水品质。'
                        },{
                            category: '静音排水系统',
                            category_sub: '',
                            brand_logo: [int24,int25],
                            des: '系统性解决排水管道静音、防堵、防臭、防漏，防二次积水。'
                        },{
                            category: '污水提升系统',
                            category_sub: '',
                            brand_logo: [int26],
                            des: '全球唯一的专利研磨泵有效解决大宅地下室水点的排水/排废提升功能。'
                        }]
                    },
                    {
                        name: '智能家具系统',
                        tableData: [{
                            category: '监控系统',
                            category_sub: '',
                            brand_logo: [int27,],
                            des: '监控系统又称之为闭路电视监控系统（英文：Closed-Circuit Television，缩写CCTV），典型的监控系统主要由前端音视频采集设备、音视频传输设备、后端存储、控制及显示设备这五大部分组成，其中后端设备可进一步分为中心控制设备和分控制设备。前、后端设备有多种构成方式，它们之间的联系（也可称作传输系统）可通过同轴电缆、双绞线、光纤、微波、无线等多种方式来实现。'
                        },{
                            category: '安防系统',
                            category_sub: '',
                            brand_logo: [int27],
                            des: '安防系统可整合您的灯光、门锁、监控系统，让您的家更安全。全方位无死角保护您的住宅，通过网络实时查看家中情况，通过反入侵加密，从而保障业主的个人隐私。'
                        },{
                            category: 'wifi覆盖',
                            category_sub: '',
                            brand_logo: [int28],
                            des: '智能WI-FI全宅覆盖是智能家居的基础，大量的指令数据要通过无线WI-FI来进行传输，同时智能手机通过WI-FI与外部世界沟通也是人们的一种重要的交流方式，因此在多房间的全宅中建设无盲区不死机的WI-FI全宅覆盖显得尤为重要，搭建千兆硬件多点POE供电AP，为用户提供稳定更快的网络环境，为高品质生活提供保障。'
                        },{
                            category: '可视对讲',
                            category_sub: '',
                            brand_logo: [int27],
                            des: '可视对讲门铃就是指你们家的门铃系统，我们常说楼宇对讲、可视门铃、可视对讲、对讲门铃等几个词语，都是同一个意思，既指一套访客对讲管理系统！严格的来说楼宇对讲就是一套访客管理系统，他是一套包含软件、硬件及售后服务的人性化管理访客的操作系统。'
                        },{
                            category: '背景音乐',
                            category_sub: '',
                            brand_logo: [int29],
                            des: '智能全宅背景音乐可以通过一台智能手机玩转全宅音乐，全分区独立手机推送，或通过APP直接控制不同分区，全宅音乐一手掌控设计场景，定时早起音乐唤醒、一键早餐音乐、一键睡眠音乐，客厅、书房、厨房、浴室场景自定义，全宅房间呼叫'
                        },{
                            category: '远程遥控',
                            category_sub: '',
                            brand_logo: [int30],
                            des: '无论何时何地，可通过远程控制，通过短信、websever、Ipad/Iphone、手机等远程控制方式控制家中电器设备。也可通过远程摄像头查看家中的情况，可以对家中的安防情况实时监控。'
                        },{
                            category: '灯光系统',
                            category_sub: '',
                            brand_logo: [int30],
                            des: '智能灯光系统是对灯光进行智能控制与管理的系统，与传统照明相比，可实现渐亮渐暗调光、一键场景单点遥控、分区控制和全宅全开全关控制，并可用遥控、定时、集中、远程等多种控制方式，用计算机对灯光进行智能编程，从而达到节能、舒适、方便的功能，智能灯光的优点是用户可以通过智能手机便可控制全宅中每一路、每一组或全部的灯光系统，无需再走到每个灯光开关面板或每一个具体房间来控制灯光。'
                        }]
                    },
                    {
                        name: '泳池水疗系统',
                        tableData: [{
                            category: '游泳池系统',
                            category_sub: '',
                            brand_logo: [int31],
                            des: '为您提供一流的水处理系统和最纯净的亲水享受，全球泳池设备行业领导品牌HAYWARD'
                        },{
                            category: '桑拿spa系统',
                            category_sub: '',
                            brand_logo: [int32],
                            des: '完整SPA系统解决方案提供商，引领行业技术发展最新潮流。'
                        }]
                    },
                    {
                        name: '窖藏系统',
                        tableData: [{
                            category: '酒、茶、雪茄、收藏品',
                            category_sub: '',
                            brand_logo: [],
                            des: '无论对私人别墅或是大型会所，如果说酒窖是整体工程中的一颗明珠，那么酒窖设计则是整个酒窖的灵魂。'
                        }]
                    },{
                        name: '结构防水系统',
                        tableData: [{
                            category: '电渗透系统',
                            category_sub: '',
                            brand_logo: [int33],
                            des: '安全节能\n' +
                                '采用220伏电源，输出低压直流电最高24伏。\n' +
                                '安全可靠低能耗，每1000平方米，约2度/天。\n' +
                                '系统运行时产生电磁辐射仅为手机的十分之一。\n' +
                                '经久耐用。\n' +
                                '防止混凝土老化开裂、钢筋生锈保护结构内侧面不发霉以及物品不损坏。\n' +
                                '与建筑同寿命。保护建筑不受侵蚀，保证建筑安全\n'
                        },{
                            category: '物理阻断系统',
                            category_sub: '',
                            brand_logo: [int34],
                            des: '德高（广州）建材有限公司，瑞士西卡集团旗下品牌，进入中国20多年，凭借创新技术、可靠品质及贴心服务，德高防水、瓷砖胶、腻子、美缝剂、技术砂浆以及巧匠工具、西卡密封胶等产品深获广大用户信赖，已成为中国市场的口碑产品。'
                        }]
                    },

                ],

            }
        },
        components: {
            NavSecond,Footer
        },
        watch: {
            '$route' (to, form) {
                this.cateList.map((v, k)=>{
                    if (v.path == to.path){
                        this.indexShow = k
                    }
                })
            }
        },
        mounted() {
            this.$wow.init()
            this.cateList.map((v, k)=>{
                if (v.path == this.$route.path){
                    this.indexShow = k
                }
            })
        },
        methods: {
            // 前行row、当前列column、当前行号rowIndex、当前列号columnIndex
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0 && row.id) {
                    if (rowIndex == 1 && row.id == 2 || row.id == 5) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex == 0 && row.id == 1 || row.id == 4){
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },

        }
    }
</script>
<style  lang="scss" scoped>
    .soft__conten{
        .title{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .cate__ul{
            text-align: center;
            margin-top: 20px;
            & > div{
                display: inline-block;
                font-size: 16px;
                font-weight: 400;
                color: #010101;
                position: relative;
                padding: 0 30px;
                cursor: pointer;
                &:nth-child(2)::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 1px;
                    width: 2px;
                    height: 16px;
                    background: #000000;
                }
                &:nth-child(2)::after{
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 1px;
                    width: 2px;
                    height: 16px;
                    background: #000000;
                }
            }
            .active{
                color: #F55E1C;
            }
        }
        .cate__imgs{
            margin-top: 50px;
            padding-bottom: 50px;
            img{
                width: 100%;
            }
        }
        .base__material{
            .base__material--tit{
                margin-top: 70px;
                font-size: 28px;
                font-weight: bold;
                color: #010101;
            }
            .base__material--des{
                margin-top: 15px;
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 24px;
            }
            .base__material--imgbg{
                position: relative;
                z-index: 22;
                margin-top: 130px;
                img{
                    width: 85%;
                    object-fit: cover;
                    height: 380px;
                    display: block;
                }
            }
            .base__material--img{
                margin-top: 145px;
                text-align: right;
                img{
                    width: 286px;
                }
                &.abs{
                    position: absolute;
                    bottom: 10px;
                    right: 7%;
                }
            }
            .base__material--imgleft{
                position: absolute;
                left: -70px;
                bottom: -80px;
                z-index: 23;
            }

            .base__material__down{
                position: absolute;
                left: 10%;
                bottom: -388px;
            }

        }
        .gray__bg{
            z-index: 2;
            position: absolute;
            right: 0;
            top: 100px;
            width: 100%;
            height: 395px;
            background: #F1F1F1;
        }
        .base__material--footerleft{
            padding: 0 10%;
            height: 360px;
            .tit{
                font-size: 28px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-bottom: 25px;
                padding-top: 120px;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 24px;
            }
        }
        .base__material--footerright{
            height: 360px;
            img{
                display: block;
                width: 100%;
            }
        }
        .base__material--footercenter{
            height: 262px;
            position: absolute;
            top: 50%;
            margin-top: -131px;
            left: 0;
            z-index: 2;
            img{
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        .barnd__banner{
            z-index: 2;
            height: 547px;
            color: #fff;
            .relative{
                top: 220px;
                padding-left: 100px;
            }
            .tit{
                font-size: 36px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 20px;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 36px;
            }
        }
        .barnd__type--cate{
            text-align: center;
            padding-top: 100px;
            padding-bottom: 30px;
            .tit{
                font-size: 36px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-bottom: 20px;
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 24px;
            }
        }
        .barnd__type--logo{
            width: 90%;
            margin: 0 auto;
            margin-bottom: 40px;
            & > div{
                width: 18%;
                margin-right: 2%;
                margin-bottom: 2%;
                background: #fff;
                img{
                    width: 100%;
                    height: 140px;
                    display: block;
                    object-fit: contain;
                }
            }
            & > div:nth-child(5n){
                margin-right: 0;
            }

        }
        .table__type{
            width: 100%;
            height: 60px;
            background: #E95313;
            font-size: 28px;
            font-weight: bold;
            color: #FFFFFF;
            text-align: center;
            line-height: 60px;
        }

    }


</style>
